import type { Component } from 'vue';
import PaymentPaypal from '@/components/payment/PaymentPaypal.vue';
import PaymentCreditcard from '@/components/payment/PaymentCreditcard.vue';
import PaymentEC from '@/components/payment/PaymentEC.vue';
import type { SupportedLocale } from '@/models/Language';
import PaypalImage from '@/assets/payment-paypal.svg';
import CreditCardImage from '@/assets/payment-card-credit.svg';
import ELVImage from '@/assets/payment-ec.svg';
import type { Localization } from '@/models/Localization';

export type PaymentMethod = 'PayPal:Reepay' | 'CreditCard:Adyen' | 'Debit:Heidelpay';

export interface PaymentMethodSignup {
	ID: PaymentMethod;
	name: Localization;
	image: string;
	view: Component;
	languages: SupportedLocale[];
}

const paymentMethods: PaymentMethodSignup[] = [
	{
		ID: 'PayPal:Reepay',
		name: (t) => t('paymentMethod.paypal'),
		image: PaypalImage,
		view: PaymentPaypal,
		languages: ['de', 'en', 'es'],
	},
	{
		ID: 'CreditCard:Adyen',
		name: (t) => t('paymentMethod.creditcard'),
		image: CreditCardImage,
		view: PaymentCreditcard,
		languages: ['de', 'en', 'es'],
	},
];

/*
* Hotfix for hiding ELV for everyone who has not a german browser.
*
* EDIT:
* We added the excludedLocales array because our payment provider doesn't
* support debit payment (SEPA Lastschrift) in Swiss, so we need to
* include all german countries but explicit exlcude Swiss to achive this.
*
* Relatet ticket:
* - https://sunplex.atlassian.net/browse/M2M-2348
*/
const excludedLocales = ['de-CH'];
if (/^de\b/.test(navigator.language) && !excludedLocales.includes(navigator.language)) {
	paymentMethods.push({
		ID: 'Debit:Heidelpay',
		name: (t) => t('paymentMethod.EC'),
		image: ELVImage,
		view: PaymentEC,
		languages: ['de'],
	});
}

export default paymentMethods;
